<template>
  <div class="page page__list">
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell"
        v-for="item in items"
        :key="item.id"
        :class="{'weui-cell_access':!item.cr_standard}"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.cr_name}}</p>
        </div>
        <div class="weui-cell__ft">
          <span class="list-item-status" v-if="item.cr_standard">本位币</span>
          <span v-else>{{item.cr_rate}}</span>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}个</label>
    </div>
    <add-button to="/document/currency_edit" />
  </div>
</template>

<script>
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/document/currency/list",
      params: {
        mode: "MAIN",
        number: 1,
        size: 20
      }
    };
  },
  methods: {
    gotoView(item) {
      if (!item.cr_standard) {
        this.$router.push("/document/currency/" + item.id);
      }
    }
  }
};
</script>